export const KNOWLEDGE = 'knowledge';

export const associationTypes = {
  isChildOf: 'isChildOf',
  replacedBy: 'replacedBy',
};
